import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/faq-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/navbar.tsx");
